/*
 * Project: LegalPlace assistant
 * File: src\components\main.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

// initializing react env
import React, { Component } from 'react';
import { connect} from 'react-redux';
import { withRouter } from 'react-router-dom';

// importing the whole components
import { LpProgressBar } from './progress';
import WizardBody from './wizard_body';
import ControlBar from './control_bar';
import Option from './option';
import PreviewModal from './modal';
import MailSection from './buy/mail_section';

// importing mthe creation of ne keys
import { generateId1, localFormat } from './utils/misc';
import {
    setSection,
    redirectToSection
} from '../redux/actions/contract';
//============================================================================

// import condition manager
import { initializeEList } from '../logic/preview_render/condition_manager';

import LpPopOver from './buy/popover';
import { TitleShimmer, ParagraphShimmer } from './misc/shimmer';

import SaveSection from './save_component_section';
import { _lp } from '../logic/wording';
import lpApp from '../app/lp_app';
import {writeHistory} from "../logic/history";
import {store} from "../globals";
// TODO: convert this into simple dumb component


/**
 * @description The main component, or the container of containers
 */
export class WizardMain extends Component {
  static hideMenu() {
    // document.getElementsByClassName("wizard-dropdown")[0].classList.remove('active');
  }

  constructor(props) {
    super(props);
    window.lp_o = this.props.options;
    this.shouldRedirect = false;
    this.state = {
        enters: false,
      };
  }

  componentWillMount() {
    initializeEList();
  }

  componentDidMount() {
    if (this.props.options) lpApp.ops.initialization.initializeVariables(this.props.options);
  }

  shouldComponentUpdate(nextProps, nextState){
    // console.log(nextProps.errors)
    if (nextProps.full_preview !== this.props.full_preview) { // remove unecessary rerender
      return false;
    }

    return true;
  }

  componentWillUpdate(nextProps) {
    if (!nextProps.wizard_loading) {
      if (lpApp.fullWidth) {
        document.body.classList.add('wizard-full');
      }
    }
  }

  componentDidUpdate() {
    if (!this.props.wizard_loading && this.props.currentSection !== this.props.sectionId - 1) {
      if (this.props.sectionId && this.props.sectionId > 0 && this.props.sectionId <= this.props.max_sections) {
        this.props.setSection(this.props.sectionId -1)
      }
    }
  }

  componentWillUnmount() {
    if (lpApp.fullWidth) {
      document.body.classList.remove('wizard-full');
    }
  }

  // <LpPopOver />
  render() {
    let { sectionTitle } = this.props;

    // In case of Email section
    if (this.props.app_state === 1) sectionTitle = (lpApp.references.customs.get('email_section_title') == 'NONE') ? _lp(' Adresse e-mail où votre document doit être envoyé') : lpApp.references.customs.get('email_section_title');

    // Save section
    if (this.props.app_state === 3) sectionTitle = (lpApp.references.customs.get('save_section_title') == 'NONE') ? _lp('Sauvegardez vos réponses') : lpApp.references.customs.get('save_section_title');

    if ((this.props.app_state === 3) && (this.props.document_id !== '' )) sectionTitle = "Sauvegarde effectuée !";

    // The dispatch of information starts here
    return (
      <div>
        <div>
          <div className="wizard-header">
            <LpProgressBar pp="" />

            {this.props.wizard_loading ? <TitleShimmer /> : (
              <div>
                <div id="wz-menu" className="wz-section-title" onMouseLeave={() => WizardMain.hideMenu()}>
                  {this.props.app_state !== 3 && (
                  <span className="wzd-count" style={{ marginRight: '4px' }}>
                    {this.props.app_state
                      ? localFormat(this.props.max_sections + 1)
                      : localFormat(this.props.currentSection + 1)}.
                  </span>
                  )}
                  {sectionTitle}
                </div>
              </div>
            )}

          </div>

          {((this.props.app_state === 1) && this.props.document_state === '') ? (<MailSection />)
            : ((this.props.app_state === 3) ? <SaveSection />
              : (
                <WizardBody is_full={this.props.full_preview}>
                  {this.props.wizard_loading ? <ParagraphShimmer />
                    : (this.props.options ? this.props.options.map(idx => (
                      <Option
                        type={idx.type}
                        label={idx.label}
                        id={idx.id}
                        key={generateId1(4)}
                        lpKey={generateId1(4)}
                        name=""
                        awlad={'option_renderer' in idx ? idx.option_renderer : []}
                        variables={idx.variable_renderer}
                        ovc="o"
                        is_multiple={idx.multiple}
                        isDuplicate={false}
                        copy={-2}
                        parent={-2}
                      />
                    )) : <div />)}
                </WizardBody>
              ))}
          <ControlBar is_full={this.props.full_preview} />
        </div>
        {lpApp.env.client_zone.width >= 765 ? <PreviewModal /> : <div />}
        {this.props.popover_state && (
        <div id="real-popover">
          <LpPopOver />
          {' '}
        </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let sTitle = 'No section presented';
  let sSection = null;

  if ('section' in state.contract) {
    sTitle = state.contract.section.label;
    sSection = state.contract.section.options_render;
  }


  return {
    empty: state.empty,
    contractTitle: state.contract.name,
    sectionTitle: sTitle,
    options: sSection,
    actual_screen: state.appstate,
    currentSection: state.contract.currentSection,
    isFinished: state.contract.isFinished,
    full_preview: state.preview,
    app_state: state.appstate,
    popover_state: state.popover,
    wizard_loading: state.loading_details.wizard,
    max_sections: Object.keys(state.contract.sections).length,
    errors: state.errors,
    show_contact: state.account_settings.show_contact,
    document_state: state.document_state.unique,
    current_document_state: state.document_state.state,
    can_render: lpApp.mutex.checkMutex('preview'),
    sure: lpApp.action_tracker.last_action === 'ADD_MULTIPLE',
    document_id: state.document_state.unique,
    show_login_modal: state.account_settings.show_login_modal,
    show_singup_modal: state.account_settings.show_singup_modal,
  };
};

const mapDispatchToProps = ( dispatch ) => {
  return{
    setSection: (id, isaNav) => {
      dispatch(setSection(id, isaNav));
      // dispatch(redirectToSection(id));
    },
    prepareData: (id) => {
      dispatch(lpApp.ops.initialization.raNextInit(id));
    },
    redirectToSection: (id) => {
      dispatch(redirectToSection(id));
    },
  }
}

export const LpWizardMain = connect(mapStateToProps, mapDispatchToProps)(WizardMain);



// WEBPACK FOOTER //
// ./src/components/main.js